// Annual Meetings for Senior Faculty

import { CCSetup } from "../../cclib/CCSetup";
import { CCStructure } from "../../cclib/CCStructure";
import { DISCUSSED_RADIO_OPTIONS, seniorStructure } from "./structure";

import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat.js";
import { CCIcon } from "../../cclib/components/UI";
import {
  cleanUpContributionSection,
  copyLastYearContribValues,
  outputContribution,
  setupDeptEMForm,
  updateContributionTotals,
  watchContributionInputs
} from "../shared/util";
import { DISABLE_EMAILS } from "../stanford_em";
dayjs.extend(LocalizedFormat);

export const seniorDataPrefix = "stanford_em_senior_";

function setupConditionallyOptionals(cc: CCSetup) {
  for (const item of seniorStructure) {
    if (
      item.type === "radio" &&
      item.options[0] === DISCUSSED_RADIO_OPTIONS[0] &&
      item.options[1] === DISCUSSED_RADIO_OPTIONS[1] &&
      item.key.endsWith("_radio")
    ) {
      const targetKey = item.key.substring(
        0,
        item.key.length - "_radio".length
      );

      cc.makeFieldConditionallyOptional(
        targetKey,
        item.key,
        DISCUSSED_RADIO_OPTIONS[0]
      );

      const wrapper = $(`[data-key="${item.key}"]`);
      wrapper.children("input").on("change", (v) => {
        if (
          v.currentTarget.dataset["radioValue"] === DISCUSSED_RADIO_OPTIONS[1]
        ) {
          $(`[data-key="${targetKey}"]`).css("display", "block");
        } else {
          $(`[data-key="${targetKey}"]`).css("display", "none");
        }
      });
      const data = cc.newDef.career[cc.viewYear].data ?? {};
      const currentlySelected =
        data[seniorDataPrefix + item.key] ?? DISCUSSED_RADIO_OPTIONS[0];
      if (currentlySelected === DISCUSSED_RADIO_OPTIONS[0]) {
        $(`[data-key="${targetKey}"]`).css("display", "none");
      } else {
        $(`[data-key="${targetKey}"]`).css("display", "block");
      }
    }
  }
}

export function addPersistentSeniorHeader(cc: CCSetup) {
  cc.addButton(
    "primary",
    CCIcon("download") + "<span>Senior Faculty Counseling Form</span>",
    {
      relative: "after",
      selector: ".downloadDataSummary"
    },
    "downloadSeniorAnnualCounseling",
    () => outputSenior(cc)
  );
}
export function updateSenior(cc: CCSetup) {
  if (cc.uninitializedYearState) {
    copyLastYearContribValues(cc);
  }
  updateContributionTotals(cc);
}
export function outputSenior(cc: CCSetup) {
  const data = cc.newDef.career[cc.viewYear].data;
  const dataOverride = {
    reputation_section: false,
    type_of_review_section: false,
    promotion_questions_section: false
  };
  for (const item of seniorStructure) {
    if (
      item.type === "radio" &&
      item.options[0] === DISCUSSED_RADIO_OPTIONS[0] &&
      item.options[1] === DISCUSSED_RADIO_OPTIONS[1] &&
      item.key.endsWith("_radio")
    ) {
      dataOverride[item.key] =
        (data[seniorDataPrefix + item.key] ?? DISCUSSED_RADIO_OPTIONS[1]) ===
        DISCUSSED_RADIO_OPTIONS[1];
    }
  }

  cc.conferenceExport(
    "stanford_em_senior.docx",
    `Form_Senior_Faculty Annual_Counseling_${cc.cvOwner.name}_${dayjs(new Date()).format("MM-DD-YYYY")}`,
    {
      ...dataOverride,
      ...outputContribution(cc)
    },
    () => ""
  );
}
export function setupSenior(cc: CCSetup) {
  const structure = new CCStructure(seniorStructure);
  cc.generateFieldsFromStructure(structure, cc.ccRoot, false);
  cleanUpContributionSection(cc);
  updateContributionTotals(cc);
  watchContributionInputs(cc);

  setupDeptEMForm(cc, "UML/UTL");

  setupConditionallyOptionals(cc);

  updateContributionTotals(cc);
  cc.appendStatusButtons(false, DISABLE_EMAILS);
  cc.update(cc.struct.structure);
  cc.contextMethods.updateLayout();
}
